import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVReviewTerrainCom} from '../containers'
function SVReviewTerrainComPage() {
    let { id } = useParams();
    let svparams = { 'id': id}
    return (
        <SVReviewTerrainCom svparams= {svparams} />
    );
}
export default SVReviewTerrainComPage

/*
import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVReviewTerrainCom} from '../containers'
function SVReviewTerrainComPage() {
    let { id } = useParams();
    let svparams = { 'id': id}
    return (
        <div>

        <p>
          SV SojournReviewContainerPage Component
        </p>
        <SVReviewTerrainCom svparams= {svparams} />
        </div>
    );
}
export default SVReviewTerrainComPage
*/